import {ApisauceInstance, create} from 'apisauce'
import {SortOrder} from "../config";


export default class Api {
    private api: ApisauceInstance;

    constructor(readonly baseURL: string = './api', readonly sortOrder: SortOrder) {
        this.api = create({
            baseURL
        })
    }

    async add(rec: Omit<Recording, "id" | "blobId">, blob: Blob) {
        const formData = new FormData()
        formData.append("data", JSON.stringify(rec))
        formData.append("audio", blob)
        const res = await this.api.post<Recording, string>("add.php", formData);
        if (res.ok) {
            return res.data
        } else throw Error(res.data ?? res.problem)

    }

    async getAll() {
        return await this.get<Recording[]>({
            sort: this.sortOrder
        }) ?? [];
    }

    async getByUser(userId: string) {
        return await this.get<Recording[]>({
            userId
        }) ?? [];
    }

    async getById(id: string) {
        try {
            return await this.get<Recording | null>({
                id
            });
        } catch (e) {
            console.error(e)
            return null
        }
    }

    private async get<T>(params: any | undefined = undefined): Promise<T | undefined> {
        const res = await this.api.get<T, string>("get.php", params)
        console.log(res);
        if (res.ok) {
            return res.data ?? undefined
        } else if (res.status === 404) {
            return undefined
        } else console.error(res.data ?? res.problem)
    }
}

